import { AnalyticsTypes } from '../../middleware/google-analytics';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../EventTrackingConstants';
import { LOCATIONS_CAROUSEL_KEY } from './constants';

export const ActionTypes = {
    SET_LOCATION: `${LOCATIONS_CAROUSEL_KEY}/SET_LOCATION`,
    CLICK_PREV: `${LOCATIONS_CAROUSEL_KEY}/CLICK_PREV`,
    CLICK_PREV_ANIMATION_START: `${LOCATIONS_CAROUSEL_KEY}/CLICK_PREV_ANIMATION_START`,
    CLICK_NEXT: `${LOCATIONS_CAROUSEL_KEY}/CLICK_NEXT`,
    CLICK_NEXT_ANIMATION_START: `${LOCATIONS_CAROUSEL_KEY}/CLICK_NEXT_ANIMATION_START`,
    TRACK_CLICK_EXPAND_MAP: `${LOCATIONS_CAROUSEL_KEY}/TRACK_CLICK_EXPAND_MAP`,
    TRACK_INSURANCE_STATUS_UPDATE: `${LOCATIONS_CAROUSEL_KEY}/TRACK_INSURANCE_STATUS_UPDATE`,
};

export const setLocation = locationId => ({
    type: ActionTypes.SET_LOCATION,
    locationId,
});

export const clickPrevAnimationStart = (locationId, callbackAfterAnimationCompletes) => ({
    type: ActionTypes.CLICK_PREV_ANIMATION_START,
    locationId,
    callbackAfterAnimationCompletes,
});

export const clickNextAnimationStart = (locationId, callbackAfterAnimationCompletes) => ({
    type: ActionTypes.CLICK_NEXT_ANIMATION_START,
    locationId,
    callbackAfterAnimationCompletes,
});

export const clickPrev = section => locationId => ({
    type: ActionTypes.CLICK_PREV,
    locationId,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Location Carousel Left Arrow',
            data: {
                Section: section,
                Component: TARGETS.LOCATION_CAROUSEL,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.LOCATION_CAROUSEL_LEFT_ARROW,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'ClickLeftArrow',
            },
        },
    },
});

export const clickNext = section => locationId => ({
    type: ActionTypes.CLICK_NEXT,
    locationId,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Location Carousel Right Arrow',
            data: {
                Section: section,
                Component: TARGETS.LOCATION_CAROUSEL,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.LOCATION_CAROUSEL_RIGHT_ARROW,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'ClickRightArrow',
            },
        },
    },
});

export const trackClickExpandMap = section => () => ({
    type: ActionTypes.TRACK_CLICK_EXPAND_MAP,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Location Carousel Map',
            data: {
                Section: section,
                Component: TARGETS.LOCATION_CAROUSEL,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.LOCATION_CAROUSEL_MAP,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'ClickMap',
            },
        },
    },
});

export const trackInsuranceStatusUpdate = section => insuranceStatus => ({
    type: ActionTypes.TRACK_INSURANCE_STATUS_UPDATE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Update Insurance Status',
            label: insuranceStatus,
            data: {
                Section: section,
                Component: TARGETS.LOCATION_CAROUSEL,
                InteractionType: INTERACTION_TYPES.UPDATE,
                Element: TARGETS.LOCATION_CAROUSEL_INSURANCE_STATUS,
                Initiator: EVENT_INITIATORS.SYSTEM,
                EventAction: 'UpdateInsuranceStatus',
                EventDetails: {
                    insuranceStatus,
                },
            },
        },
    },
});
